/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import {AnimatePresence, motion} from "motion/react";
import DisplayIcon from "../Icons/DisplayIcon.jsx";

const MainMenuActionBar = ({selectedElements, onClear, onDeleteAll, onOpenAllInTabs}) => {
    const count = selectedElements.length;

    return (
        <AnimatePresence>
            {count > 1 && (
                <motion.div
                    key="action-bar"
                    initial={{opacity: 0, y: 20}}
                    animate={{opacity: 1, y: 0}}
                    exit={{opacity: 0, y: 20}}
                    transition={{duration: 0.18, ease: "easeOut"}}
                    className="absolute bottom-0 left-0 right-0 mx-2 mb-2 flex items-center gap-2 rounded-lg flex-col bg-blue-600 px-3 py-2 text-white shadow-lg"
                >
                    <div className={"flex w-full"}>
                        <div className="select-none  grow text-sm font-medium">
                            {count} selected
                        </div>
                        <button
                            type="button"
                            onClick={onClear}
                            className="inline-flex items-center justify-center rounded-md px-1.5 py-1 hover:bg-blue-500 transition-colors"
                            aria-label="Clear selection"
                        >
                            <DisplayIcon iconName={"IoCloseOutline"} className="h-4 w-4"/>
                        </button>
                    </div>

                    <div className=" flex items-center gap-1.5">
                        <button
                            type="button"
                            onClick={onOpenAllInTabs}
                            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium hover:bg-blue-500 transition-colors select-none"
                        >
                            <DisplayIcon iconName={"PiArrowSquareOut"} className="h-3.5 w-3.5"/>
                            Open all in tabs
                        </button>

                        <button
                            type="button"
                            onClick={onDeleteAll}
                            className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-xs font-medium hover:bg-blue-500 transition-colors select-none"
                        >
                            <DisplayIcon iconName={"IoTrashOutline"} className="h-3.5 w-3.5"/>
                            Delete all
                        </button>


                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

MainMenuActionBar.propTypes = {};

export default MainMenuActionBar;